<template>
  <div>
    <transition appear @before-enter="$animations.beforeEnterLogoArea" @enter="$animations.enterLogoArea">
      <Logo></Logo>
    </transition>
    <img
        src="../assets/images/icons/Blue/Arrow.png"
        alt="Arrow"
        width="40px"
        style="cursor: pointer"
        @click="goToNextPage"
    />

    <div class="columns is-centered mb-0">
      <div class="column is-half ps-5" style="text-align: center">
        <p class="subhead-line is-size-4" style="line-height: 10px">
          <img src="../assets/images/icons/Blue/Hand.png" alt="hi-img" width="7%" />
          {{ $root.selectedLanguageData.hello
          }}<span class="ml-3" style="margin-left: 0.5rem !important;"
        >{{ $root.formData.employer_name}}</span
        >
        </p>
        <p :class="`text-center mx-3 ${$root.selectedLanguage === `ta`
              ? `ta-he-line`
              : $root.selectedLanguage === `si`
                ? `si-he-line`
                : `en-he-line`
              }`">
          {{ $root.selectedLanguageData.welcome_back }}
        </p>
        <!--        <p class="headline-font" style="line-height: 1.4">-->
        <!--          -->
        <!--        </p>-->
      </div>
    </div>
    <div style="display: flex; justify-content: center">
      <div
          style="border-bottom: 2px solid rgba(35, 31, 32, 0.79); opacity: 0.5"
          class="underline"
      ></div>
    </div>
    <div class="dashboard-body-content-area">
      <div>
        <b-table
            :data="tableData"
            :is-loading="isLoading"
            :has-pagination="true"
            :pagination-simple="true"
        >
          <b-table-column field="customer_nic" label="Customer NIC" width="40" :td-attrs="columnTdAttrs" v-slot="props">
            {{ props.row.customer_nic }}
          </b-table-column>

          <b-table-column field="account_type" label="Account Type" width="40" :td-attrs="columnTdAttrs" v-slot="props">
            {{ props.row.account_type }}
          </b-table-column>

          <b-table-column field="account_category" label="Account Category" width="40" :td-attrs="columnTdAttrs" v-slot="props">
            {{ props.row.account }}
          </b-table-column>

          <b-table-column field="selected_account" label="Selected Account" width="40" :td-attrs="columnTdAttrs" v-slot="props">
            {{ props.row.selected_account }}
          </b-table-column>

          <b-table-column field="created_at" label="Created At" width="40" :td-attrs="columnTdAttrs" v-slot="props">
            {{ props.row.created_at }}
          </b-table-column>

          <b-table-column field="updated_at" label="Updated At" width="40" :td-attrs="columnTdAttrs" v-slot="props">
            {{ props.row.updated_at }}
          </b-table-column>

          <b-table-column field="status" label="Status" width="40" :td-attrs="columnTdAttrs" v-slot="props">
            {{ props.row.status === 'approved_pending' ? 'Pending Approval' : capitalizeFirstLetter(props.row.status) }}

          </b-table-column>

          <b-table-column field="action" label="Action" width="40" :td-attrs="columnTdAttrs" v-slot="props">
            <b-tooltip label="Video Call Already Completed"
                       type="is-primary is-light"
                       position="is-bottom"
                       :active="['rejected', 'refer-to-branch', 'approved_pending', 'finished', 'approved'].includes(props.row.status)">
            <b-button @click="actionButtonHandler(props.row)"
                      v-if="props.row.status === 'Incomplete' || 'Complete' || 'Pending'"
                      class="is-primary"
                      :disabled="['rejected', 'refer-to-branch', 'approved_pending', 'finished', 'approved'].includes(props.row.status)"

                      :loading="continueButtonIsLoading">
              <span v-if="props.row.status === 'Incomplete'">Continue</span>
              <span v-else-if="props.row.status === 'Complete' || 'Pending' ">Re-schedule video call</span></b-button></b-tooltip>

<!--            <b-button @click="actionButtonHandler(props.row)"
                      v-if="props.row.status === 'Incomplete'"
                      class="is-primary"
                      :loading="continueButtonIsLoading">
              Continue
            </b-button>
            <b-button v-else-if="['Complete', 'Pending'].includes(props.row.status)"
                      :disabled="['Rejected', 'Refer-to-branch', 'Approved-Pending', 'Finished', 'Approved'].includes(props.row.status)"
                      class="is-primary"
                      @click="actionButtonHandler(props.row)">
              Re-schedule video call
            </b-button>-->
          </b-table-column>



        </b-table>
      </div>

    </div>

    <b-modal v-model="isReshcduleModalActive" :width="940" scroll="keep">
      <div class="card px-3 py-5   " style="width: 80%; margin: 0 auto ">
        <transition appear @before-enter="$animations.beforeEnterAbove" @enter="$animations.enterAbove">
          <div class="columns is-centered">
            <div class="column is-full ps-5" style="text-align: center">
              <img src="../assets/images/icons/Blue/Frame 37763.png" alt="contact-info-img" width="70" height="70" />
              <p :class="`text-center mx-3 mb-2 ${$root.selectedLanguage === `ta`
              ? `ta-he-line`
              : $root.selectedLanguage === `si`
                ? `si-he-line`
                : `en-he-line`
              }`"
                 style="font-family: OpenSans-Bold;">
                {{ $root.selectedLanguageData.videocalldetails }}
              </p>
              <p :class="`${$root.selectedLanguage === `ta`
              ? `ta-sub-line`
              : $root.selectedLanguage === `si`
                ? `si-sub-line`
                : `en-sub-line`
              }`"
                 style="font-family: OpenSans-Bold;">
                {{ $root.selectedLanguageData.selectthedateandtimeforthevideocall }}
              </p>
              <p style="font-family: OpenSans-Regular;">
                {{ $root.selectedLanguageData.fill_the_below_form }}
              </p>
            </div>
          </div>
        </transition>
        <ValidationObserver v-slot="{ invalid }">
          <form @submit.prevent="">
            <div class="columns is-centered">
              <div class="column is-three-quarters pt-3 ps-5">

                <div class="mt-4 columns">
                  <div class="column is-half">
                    <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.preferreddate
                      }}<span class="has-text-danger">*</span>
                    </label>
                    <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                      <b-datepicker
                          position="is-top-right"
                          v-model="videoCallDate"
                          :unselectable-days-of-week="[0,6]"
                          :unselectable-dates="unselectableDates"
                          :min-date="minDate"
                          icon-right="calendar"
                          @input="()=>{
                        if(selecteableTimeSlotsArray !== [])
                        {
                          selecteableTimeSlotsArray = []
                        }
                        if(new Date(videoCallDate)> new Date()){
                          isToday = false
                          heelo()
                          
                        }
                        setTimeout(getTimeSlotList(), 100)
                      }"
                          >
                      </b-datepicker>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>

                  </div>
                  <div class="column is-half">
                    <label :class="`${$root.selectedLanguage === `ta`
                    ? `ta-label`
                    : $root.selectedLanguage === `si`
                      ? `si-label`
                      : ``
                    }`">{{ $root.selectedLanguageData.preferredtime
                      }}<span class="has-text-danger">*</span>
                    </label>
                    <ValidationProvider :rules="{ required: true }" v-slot="{ errors }">
                      <b-select
                          @focus="$inputFocused('videoCallTimeSlot')"
                          @input="$inputChanged('videoCallTimeSlot')"
                          @blur="$inputBlured('videoCallTimeSlot')"
                          v-model="videoCallTimeSlot"  expanded
                          >
                        <option v-for="(timeSlot, index) in selecteableTimeSlotsArray" :value="timeSlot.time" :key="index" :disabled="timeSlot.isDisabled === true">
                          {{ timeSlot.time }}
                        </option>
                      </b-select>
                      <span class="has-text-danger">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>


              </div>

            </div>
            <p style="width: 75%; margin: 0 auto"><span>{{$root.selectedLanguageData.note}}</span> {{$root.selectedLanguageData.videocallshedulenote}}</p>

            <div class="is-centered columns my-3">
              <div
                  class="column is-5 is-offset-4 is-flex is-flex-direction-row-reverse"
              >
                <b-button
                    :disabled="invalid"
                    :class="`is-primary  ${
                  $root.selectedLanguage === `ta`
                    ? `continue-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `continue-button-si`
                    : `continue-button-en`
                }`"
                    @click="videoCallRescheduler()"
                >

                  <!-- :disabled="invalid || userCode !== $root.formData.countryCode" -->

                  {{ $root.selectedLanguageData.reshecdule }}
                </b-button>
                <b-button
                    @click="()=>{isReshcduleModalActive=false}"
                    :class="` ${
                  $root.selectedLanguage === `ta`
                    ? `back-button-ta`
                    : $root.selectedLanguage === `si`
                    ? `back-button-si`
                    : `back-button-en`
                }`"

                >{{ $root.selectedLanguageData.back }}
                </b-button>
              </div>
            </div>

          </form>
        </ValidationObserver>



      </div>
    </b-modal>

  </div>
</template>

<script>
import Logo from "@/components/NsbKycLogo";
import {getBranchesList, getOtherBankList, getCountyCodeList} from "@/util/util"


export default {
  components: {
    Logo,

  },
  data() {
    return {
      timeObj: new Date(),
      timeGap: null,
      currentTime:"",
      endTime:"",
      minDate: "",
      isToday: true,
      selecteableTimeSlotsArray: [],
      timeSlotsArray: [],
      getBranchesList : getBranchesList,
      getOtherBankList : getOtherBankList,
      getCountyCodeList : getCountyCodeList,
      closedTime : "",
      videoCallDate: '',
      videoCallTimeSlot: '',
      isReshcduleModalActive : false,
      isLoading: true,
      tableData: [],
      kycToken: '',
      colorCode1: '',
      colorCode2: '',
      colorCode3: '',
      colorCode4: '',
      colorCode5: '',
      colorCode6: '',
      colorCode7: '',
      colorCode8: '',
      colorCode9: '',
      colorCode10: '',
      colorCode11: '',
      colorCode12: '',
      continueButtonIsLoading : false,
      tokenAndColorCodes : [],
      unselectableDates : [],
      bankHolyDays : [],
      selectedApplicationID : "",
      columns: [

        {
          field: 'customer_nic',
          label: 'Customer NIC',
        },
        {
          field: 'account_type',
          label: 'Account Type',
        },
        {
          field: 'account',
          label: 'Account Category',
        },
        {
          field: 'selected_account',
          label: 'Selected Account',
        },
        {
          field: 'created_at',
          label: 'Created At',


        },
        {
          field: 'updated_at',
          label: 'Updated At',


        },
        {
          field: 'status',
          label: 'Status',
        },
        {
          field: 'action',
          label: 'Action',

        }
      ],
    }
  },
  methods:{
    heelo(){
      console.log("Worked");
    },

    actionButtonHandler(applicationObj){
      console.log("application stat ", applicationObj.status)

      // eslint-disable-next-line no-constant-condition
      if(applicationObj.status == 'scheduled' || applicationObj.status =='incomplete' || applicationObj.status =='pending'){
         //this.videoCallRescheduler(applicationObj)
        
        // console.log("this. isReshcduleModalActive ", this.isReshcduleModalActive)
        // console.log("complete kicked")getTokenAndColorCodes
        console.log("application staty ", applicationObj.status)

        this.isReshcduleModalActive = true
        this.getHolidayList();
        //  this.timeScheduleCalculator()
        this.getBankAvailableTime();
        // this.getTimeSlotList()
        this.selectedApplicationID = applicationObj.id
        
      }
      else if(applicationObj.status === 'Incomplete'){
        this.$root.isFromStatusCheck = 1;
        this.continueInCompleteApplication(applicationObj)
        console.log("Incomplete kicked")

      }
    },

    videoCallRescheduler(){
      // console.log("Incomplete	ApplicationId", incompleteApplicationId.id)

      try {
        // window.element = this;

        this.$http
            .post(
                this.$baseURL + "/updatePreferedDateAndTime",
                {
                  "id" : this.selectedApplicationID,
                  "customer_preferred_date" : this.videoCallDate,
                  "customer_preferred_time" : this.videoCallTimeSlot

                },
            )
            .then((response) => {
              this.isLoading = false;
              if (response.data.success) {
                console.log(response.data)
                this.isReshcduleModalActive=false
                this.$buefy.toast.open({
                  message: "Re-schedule Video Call successfully",
                  type: "is-primary",
                });
              }
            })
            .catch((response) => {
              this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
              });
            });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed Fetch data",
          type: "is-danger",
        });
      }

    },

    continueInCompleteApplication(incompleteApplicationId){
      let formDataObject = JSON.parse(incompleteApplicationId.filled_data)
      console.log("FormData object" ,formDataObject)
      this.$root.formData = formDataObject;
      if(this.$root.formData.account_holder_passport_issue_date !=''){
        this.$root.formData.account_holder_passport_issue_date= new Date(this.$root.formData.account_holder_passport_issue_date)
        this.$root.formData.account_holder_passport_expiry_date = new Date(this.$root.formData.account_holder_passport_expiry_date)
        console.log("account_holder_passport_issue_date",this.$root.formData.account_holder_passport_issue_date)
        console.log("account_holder_passport_expiry_date",this.$root.formData.account_holder_passport_expiry_date)
      }
      if(this.$root.formData.account_holder_dob !=''){
        this.$root.formData.account_holder_dob= new Date(this.$root.formData.account_holder_dob)
        console.log("account_holder_dob",this.$root.formData.account_holder_dob)

      }
      if(this.$root.formData.guardian_passport_issue_date !=''){
        this.$root.formData.guardian_passport_issue_date= new Date(this.$root.formData.guardian_passport_issue_date)
        this.$root.formData.guardian_passport_expiry_date = new Date(this.$root.formData.guardian_passport_expiry_date)
        console.log("guardian_passport_issue_date",this.$root.formData.guardian_passport_issue_date)
        console.log("guardian_passport_expiry_date",this.$root.formData.guardian_passport_expiry_date)
      }
      if (this.$root.formData.nomineesData && this.$root.formData.nomineesData.length > 0) {
        this.$root.formData.nomineesData.forEach(nominee => {
          if (nominee.dob !== '') {
            nominee.dob = new Date(nominee.dob);
            console.log("Nominee Date of Birth", nominee.dob);
          }
        });
      }
      console.log("form filled",incompleteApplicationId.form_filled)

      this.getTokenAndColorCodes(incompleteApplicationId.id, incompleteApplicationId.next_route,incompleteApplicationId.form_filled)
      this.$router.push(incompleteApplicationId.next_route)

    },

    capitalizeFirstLetter(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },



    getDataStatusCheck(){
      try {
        window.element = this;

        this.$http
            .post(
                this.$baseURL + "/getDataStatusCheck",
                {
                  nicNumber : this.$root.formData.statusNic,

                },

            )
            .then((response) => {
              this.isLoading = false;
              if (response.data.success) {

                if (Array.isArray(response.data.data.list)) {
                  this.tableData = response.data.data.list;
                } else if (typeof response.data.data.list === 'object') {
                  this.tableData = [response.data.data.list]; // Convert single object to an array
                }
                /*this.tableData = response.data.data.list;
                console.log("data",this.tableData)*/
              }
            })
            .catch((response) => {
              this.$buefy.toast.open({
                message: response.message,
                type: "is-danger",
              });
            });
      } catch (e) {
        this.$buefy.toast.open({
          message: "Failed Fetch data",
          type: "is-danger",
        });
      }

    },

    getTokenAndColorCodes(idNumber, nextRoute, formFilled){
      try{
        this.continueButtonIsLoading = true

        const comp = this


        this.$http
            .post(this.$baseURL + "/updateTokenStatusCheck", {id : idNumber , isFormFilled :formFilled}
            )
            .then((response) => {
              // console.log(response.data);
              comp.continueButtonIsLoading = false
              comp.tokenAndColorCodes = response.data.data
              comp.$root.formData.color_code1 = response.data.data.color_code1
              comp.$root.formData.color_code2 = response.data.data.color_code2
              comp.$root.formData.color_code3 = response.data.data.color_code3
              comp.$root.formData.color_code4 = response.data.data.color_code4
              comp.$root.formData.color_code5 = response.data.data.color_code5
              comp.$root.formData.color_code6 = response.data.data.color_code6
              comp.$root.formData.color_code7 = response.data.data.color_code7
              comp.$root.formData.color_code8 = response.data.data.color_code8
              comp.$root.formData.color_code9 = response.data.data.color_code9
              comp.$root.formData.color_code10 = response.data.data.color_code10
              comp.$root.formData.color_code11 = response.data.data.color_code11
              comp.$root.formData.color_code12 = response.data.data.color_code12
              comp.$root.formData.color_code13 = response.data.data.color_code13
              comp.$root.formData.color_code14 = response.data.data.color_code14
              comp.$root.formData.color_code15 = response.data.data.color_code15
              comp.$root.formData.color_code16 = response.data.data.color_code16
              comp.$root.formData.kyc_token = response.data.data.token
              console.log(comp.$root.formData.kyc_token);
              setTimeout(()=>{comp.getBranchesList();comp.getOtherBankList(); comp.getCountyCodeList()
              if(nextRoute === "video-call-schedule")
              {
                this.getBankAvailableTime()
              }}, 500)
              
              console.log("token and color codes", comp.tokenAndColorCodes)
            })
      }catch(err){
        console.log(err)
      }
    },

    // goToIncompleteApplication(){
    //
    // },

    goToNextPage(){

      this.$router.push("enter-name");

    },
      getHolidayList(){
      try{
        console.log("----------start-----------");
        this.$http
            .post(this.$baseURL + "/getHolidays", {}, {
              
            })
            .then((response) => {
              console.log("bank Holidays")
              console.log(response.data);
              this.bankHolyDays = response.data;
              this.bankHolyDaysFormatter();

              console.log("---------------------");
            })

        // this.disabledDates();
      } catch (err) {
        console.log(err)
      }
    },

        bankHolyDaysFormatter(){
          this.bankHolyDays.forEach((holyDay)=>{
          let dateParts = holyDay.date.split("-");
          let year = parseInt(dateParts[0]);
          let month = parseInt(dateParts[1])-1;
          let date = parseInt(dateParts[2]);
          this.unselectableDates.push(new Date(year, month, date))
        })
      return this.unselectableDates

    },

       getTimeSlotList(){
      try{
        console.log("----------start-----------");


        this.$http
            .post(this.$baseURL + "/getTimeSlots", {"is_today" : this.isToday},{
         
            })
            .then((response) => {
              const comp = this;
              console.log(response.data.data);
              comp.timeSlotsArray = response.data.data;
           
            
              // this.timeSchedulerConcatonator()
            for (let i=0; i<=comp.timeSlotsArray.length-2; i++){
              
                      let timeObj={
                        time :  comp.timeSlotsArray[i].time + " to " + comp.timeSlotsArray[i+1].time,
                        isDisabled : comp.timeSlotsArray[i].disable,
                        };
                        console.log("timeObj", timeObj)
                      comp.selecteableTimeSlotsArray.push(timeObj)
            }
              
            })

      }catch(err){
        console.log(err)
      }
    },

    getBankAvailableTime(){
         try{
       
        this.$http
            .post(this.$baseURL + "/bankOpeningClosingTime", {"is_today" : this.isToday},{
         
            })
            .then((response) => {
             console.log("getBankAvailableTime",response.data)
              this.closedTime = response.data.bankEndTime
              let [hours, minutes] = this.closedTime.split(':').map(Number);
              this.endTime = hours*60 + minutes
              this.currentTime = (this.timeObj.getHours()*60)+this.timeObj.getMinutes()
   
              let timeGap = this.endTime - this.currentTime
              console.log("timeGap", timeGap)
              console.log("this.endTime", this.endTime)
              console.log("this.currentTime", this.currentTime)
              if (timeGap>=120){
                  this.minDate = new Date(this.timeObj.getFullYear(), this.timeObj.getMonth(), this.timeObj.getDate())
                  console.log( "Min Date " +this.minDate)
                  console.log("Day "+ this.timeObj.getDate())
                  this.isToday = true;
              }
              else {
                  this.minDate = new Date(this.timeObj.getFullYear(), this.timeObj.getMonth(), this.timeObj.getDate()+1)
                  console.log( "Min Date " +this.minDate)
                  console.log("Day "+ this.timeObj.getDate())
                  this.isToday = false;
              }
              console.log("this.isToday", this.isToday)
            })

      }catch(err){
        console.log(err)
      }
    },

    //   timeSchedulerConcatonator(){
      
           
    //   for (let i=0; i<=this.timeSlotsArray.length-2; i++){
    //     let timeObj={
    //                     time :  this.timeSlotsArray[i].time + " to " + this.timeSlotsArray[i+1].time,
    //                     isDisabled : this.timeSlotsArray[i].disable,
    //                     };
    //     this.selecteableTimeSlotsArray.push(timeObj)
    //   }
    // },

    //  timeScheduleCalculator(){
      
    //   this.getBankAvailableTime()
    //   this.currentTime = (this.timeObj.getHours()*60)+this.timeObj.getMinutes()
   
    //   let timeGap = this.endTime - this.currentTime
    //      console.log("timeGap", timeGap)
    //   console.log("this.endTime", this.endTime)
    //   console.log("this.currentTime", this.currentTime)
    //   if (timeGap>=120){
    //     this.minDate = new Date(this.timeObj.getFullYear(), this.timeObj.getMonth(), this.timeObj.getDate())
    //     console.log( "Min Date " +this.minDate)
    //     console.log("Day "+ this.timeObj.getDate())
    //     this.isToday = true;
    //   }
    //   else {
    //     this.minDate = new Date(this.timeObj.getFullYear(), this.timeObj.getMonth(), this.timeObj.getDate()+1)
    //     console.log( "Min Date " +this.minDate)
    //     console.log("Day "+ this.timeObj.getDate())
    //     this.isToday = false;
    //   }

    // },



  },
  mounted: function () {

    this.getDataStatusCheck();
    //  this.getHolidayList();
    
     






  },
}
</script>

<style>


</style>